import TriangleElements				from "../../graphics/TriangleElements";

class ParticleData
{
	public particleIndex:number /*uint*/;
	public numVertices:number /*uint*/;
	public startVertexIndex:number /*uint*/;
	public elements:TriangleElements;
}

export default ParticleData